// extracted by mini-css-extract-plugin
module.exports = {"rightSideDrawerHeader":"RightSideDrawerHeader_rightSideDrawerHeader__1mIzh"};